
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import firebase from 'firebase/compat/app'
import 'firebase/firestore';
import "firebase/analytics";

const APP_BUILD = 'anthem-anthem 0.1.0 build-2026-07-16-01'

Vue.config.productionTip = false
window.__ANTHEM_BUILD__ = APP_BUILD

new Vue({
  router,
  store,
  render: function (h) { return h(App) },
  created(){
    const firebaseConfig = {
      apiKey: "AIzaSyDcMS8cMcaje4z__by0NGmN-CErjooB9Ag",
      authDomain: "anthem-anthem.firebaseapp.com",
      databaseURL: "https://anthem-anthem-default-rtdb.asia-southeast1.firebasedatabase.app",
      projectId: "anthem-anthem",
      storageBucket: "anthem-anthem.appspot.com",
      messagingSenderId: "851409298794",
      appId: "1:851409298794:web:eaea8ffc1ef795a481b113",
      measurementId: "G-TCKBXZXS4D"
    };
    if (!firebase.apps.length) {
      firebase.initializeApp(firebaseConfig)
    }

    //firebase.analytics();
    
  }
}).$mount('#app')
